import React, { useEffect, useState } from "react";
import { ApiCaller } from "../../config/api/api";
const Footer = () => {
  const [itemsImage, setItemsImage] = useState(null);

  useEffect(() => {
    const fetchDataImage = async () => {
      try {
        const data = await ApiCaller("food-gallery/", "GET");

        setItemsImage(data);
      } catch (error) {
        console.error('"Error at gallery Api', error.message);
      }
    };
    fetchDataImage();
  }, []);

  return (
    <footer className="bg-black">
      <div className="py-14 px-5 sm:px-14 md:px-16 lg:px-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-5">
          <div style={{ width: "100%" }}>
            <iframe
              title="Classy Cafe Bar & Restaurant Location Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2705.5759255858025!2d77.21810277416574!3d28.56924058695449!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce3ba1b8a685d%3A0x94772191312d0f2!2sClassy%20Cafe%20Bar%20%26%20Restaurant!5e1!3m2!1sen!2sin!4v1741257583100!5m2!1sen!2sin"
              width="100%"
              height="250"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
            <div className="text-amber-300 text-sm py-3">
              G-24, Second Floor , South Extension Part-1, main Market , New
              Delhi-110048
            </div>
            <div className="flex items-center gap-2">
              <div className="font-bold text-white text-sm">MAIL US :</div>
              <div>
                <a
                  className="text-amber-300"
                  href="mailto:classycafebar.resto@gmail.com or classycafe19@gmail.com"
                >
                  classycafebar.resto@gmail.com or classycafe19@gmail.com
                </a>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="font-bold text-white text-sm">CALL US@</div>
              <div>
                <a className="text-amber-300" href="tel:+911141684572">
                  +911141684572
                </a>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="text-white font-bold text-sm">Whatsapp @</div>
              <div className="text-amber-300">8527221291</div>
            </div>
          </div>
          <div className="grid grid-cols-5 gap-1">
            {itemsImage && itemsImage.results ? (
              itemsImage.results.map((items, id) => (
                <div key={id}>
                  <img
                    src={items.image_url}
                    alt="items.cover_image"
                    className="w-full object-cover h-28"
                  />
                </div>
              ))
            ) : (
              <div>Loading...</div>
            )}
          </div>
        </div>
      </div>
      <div className="bg-gray-950 px-5 sm:px-14 md:px-16 lg:px-20 py-7">
        <div className="block md:flex lg:flex justify-between text-center">
          <div className="text-white">
            © All right reserved. Powered by Liangtuang Technologies
          </div>
          <div>
            <ul className="flex gap-4 items-center justify-center">
              <li>
                <a href="/" className="text-white">
                  Home
                </a>
              </li>
              <li>
                <a href="/" className="text-white">
                  About Us
                </a>
              </li>
              <li>
                <a href="/" className="text-white">
                  Reach Us
                </a>
              </li>
              <li>
                <a href="/" className="text-white">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
